export const userInfo = state => state.userInfo
export const token = state => state.token
export const hasLogin = state => state.hasLogin




// WEBPACK FOOTER //
// ./src/store/getters.js